import { render, staticRenderFns } from "./job-status.component.vue?vue&type=template&id=17463f56"
import script from "./job-status.component.ts?vue&type=script&lang=ts&external"
export * from "./job-status.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17463f56')) {
      api.createRecord('17463f56', component.options)
    } else {
      api.reload('17463f56', component.options)
    }
    module.hot.accept("./job-status.component.vue?vue&type=template&id=17463f56", function () {
      api.rerender('17463f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/job-status/job-status.component.vue"
export default component.exports